<nav class="nav nav-desktop mx-lg-3 d-none d-lg-block" 
    [ngClass]="{'b2b' : user.segment === 'B2B', 'b2c' : user.segment === 'B2C'}">
    <ng-container *ngFor="let item of submenu">
        <a *ngIf="item.routerPath"
            class="nav-link align"
            [id]="item.reference || ''"
            [class.menu-selected]="item.active"
            [routerLink]="item.routerPath"
            routerLinkActive="menu-selected"
            [routerLinkActiveOptions]="{ exact: false }">
            <span class="icon-circle d-flex justify-content-center align-items-center">
                <span class="icon {{ item.icon }}"></span>
            </span>
            <span class="menu-name">{{ item.name | uppercase }}</span>
        </a>
        <a *ngIf="item.externalLink"
            class="nav-link align"
            routerLinkActive="menu-selected"
            href="{{item.externalLink}}">
            <span class="icon-circle d-flex justify-content-center align-items-center">
                <span class="icon {{ item.icon }}"></span>
            </span>
            <span class="menu-name">{{ item.name | uppercase }}</span>
        </a>
    </ng-container>
</nav>

<ul class="nav nav-fill flex-nowrap nav-mobile d-flex d-lg-none">
    <li [id]="item.reference || ''" class="nav-item" *ngFor="let item of submenu">
        <a *ngIf="item.routerPath"
            class="nav-link p-2"
            [class.menu-selected]="item.active"
            [routerLink]="item.routerPath"
            routerLinkActive="menu-selected"
            [routerLinkActiveOptions]="{ exact: false }">
            <span class="icon-circle">
                <span class="icon {{ item.icon }}"></span>
            </span>
            <span class="menu-name">{{ item.name }}</span>
        </a>
        <a *ngIf="item.externalLink"
            class="nav-link p-2"
            routerLinkActive="menu-selected"
            href="{{item.externalLink}}">
            <span class="icon-circle">
                <span class="icon {{ item.icon }}"></span>
            </span>
            <span class="menu-name">{{ item.name }}</span>
        </a>
    </li>
</ul> 

